"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const alterColumnToText = async (knex, table)=>{
    await knex.schema.alterTable(table, (t)=>{
        t.text('description').alter();
    });
};
const alterColumnToString = async (knex, table)=>{
    await knex.schema.alterTable(table, (t)=>{
        t.string('description', 255).alter();
    });
};
const up = async (knex)=>{
    await alterColumnToText(knex, _globals.MetaTable.COLUMNS);
    await alterColumnToText(knex, _globals.MetaTable.MODELS);
    await alterColumnToText(knex, _globals.MetaTable.VIEWS);
};
const down = async (knex)=>{
    await alterColumnToString(knex, _globals.MetaTable.COLUMNS);
    await alterColumnToString(knex, _globals.MetaTable.MODELS);
    await alterColumnToString(knex, _globals.MetaTable.VIEWS);
};
